import { useMutation } from '@tanstack/react-query';

import API from '@api/API';

import { useCurrentUserLocation } from '@hooks/useCurrentUserLocation';

import Button from '@components/buttons/Button';
import Card from '@components/layout/Card/Card';

const useInitializePromoterMutation = () => {
  const { currentLocation } = useCurrentUserLocation({ context: 'useInitializePromoterMutation' });

  const { isPending: isSubmitting, mutateAsync: initializePromoterAsync } = useMutation({
    mutationFn: () => {
      return API.post<{ url: string }, {}>('/v1/promoter/me', { coordinates: currentLocation });
    },
  });

  return {
    isSubmitting,
    initializePromoterAsync,
  };
};

export const EventbriteCard = () => {
  const { initializePromoterAsync } = useInitializePromoterMutation();

  const handleLinkEventbrite = async () => {
    const { url } = await initializePromoterAsync();
    window.location.href = url;
  };

  return (
    <Card>
      <Card.Header title="Connect Eventbrite" subtitle="We need you to do one step" />
      <Card.Body>
        <p>
          We need you to connect your Eventbrite organizer profile. This will allow us to get your
          events and track the "check-in" status of your guests.
        </p>
      </Card.Body>
      <Card.Footer>
        <Button onClick={handleLinkEventbrite}>Connect Eventbrite</Button>
      </Card.Footer>
    </Card>
  );
};
